<template>
  <div class="quick-transfer-skeleton">
    <div v-for="i in 2" :key="i" class="quick-transfer-skeleton__section">
      <Skeleton height="1rem" width="70px" class="short" />
      <Skeleton height="2rem" width="100%" class="long" />
      <Skeleton height="2rem" width="100%" class="long" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.quick-transfer-skeleton {
  display: flex;
  flex-direction: column;
  gap: $static-space-4;
  width: 100%;
  height: 100%;

  &__section {
    .short {
      margin-bottom: $static-space-4;
    }

    .long {
      margin-bottom: $static-space-2;
    }
  }
}
</style>
